import { Box, Button, InputBase, Typography } from "@mui/material";
import hero from "../Assets/view-animated-cartoon-character-shopping-goods 1.svg"
import { useState,useEffect} from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateFirst_name, updateId, updateLast_name, updateMobileno, updateSelectedHub } from "../Redux/user";
import { updatepageName } from "../Redux/page";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import CustomAxios from "../utils/CustomAxios";
import CircularProgress from '@mui/material/CircularProgress';
export function Login() {
    const toast = useRef(null);
    const [registration, setRegistration] = useState('')
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        mobileno: '',
    });
    const mobileno = useSelector(state => state.user.mobileno)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Allow only numbers (prevent letters or special characters)
        if (/^\d*$/.test(value)) {
            setFormData({ ...formData, [name]: value });
        }
    };

    const isDisabled = formData.mobileno.length !== 10; 
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate mobile number length
        if (formData.mobileno.length !== 10) {
            toast.current.show({ severity: 'error', summary: 'Invalid Number', detail: 'Mobile number must be exactly 10 digits', life: 3000 });
            return;
        }

        setLoading(true);
        try {
            const response = await CustomAxios.post(`login/`, formData);
            const responseData = response.data;
            const data = Array.isArray(responseData) ? responseData[0] : responseData;
            console.log('Login Response:', data.message);

            if (data.message === "OTP sent to user") {
                localStorage.setItem('user_id', data.user_id);  
                localStorage.setItem('mobileno', formData.mobileno);  
                
                // console.log("=== LOGIN RESPONSE DEBUG ===");
                // console.log("User role:", data.role);
                // console.log("Inventory IDs:", data.inventory_ids);
                // console.log("=== END LOGIN RESPONSE DEBUG ===");
                
                if (Array.isArray(data.inventory_ids) && data.inventory_ids.length > 0) {
                    localStorage.setItem('hub', JSON.stringify(data.inventory_ids));
                    localStorage.setItem('selected_hub', JSON.stringify(data.inventory_ids));
                    dispatch(updateSelectedHub(data.inventory_ids));
                    // console.log("Set hub to:", data.inventory_ids);
                } else if (data.role === 'super_admin') {
                    // Super Admin gets all hubs - we'll handle this in the frontend
                    localStorage.setItem('hub', JSON.stringify([]));
                    localStorage.setItem('selected_hub', JSON.stringify([]));
                    dispatch(updateSelectedHub([]));
                    // console.log("Super Admin - set empty hub array");
                } else {
                    localStorage.setItem('hub', JSON.stringify([]));
                    localStorage.setItem('selected_hub', JSON.stringify([]));
                    dispatch(updateSelectedHub([]));
                    // console.log("No inventory IDs - set empty hub array");
                }

                navigate("/otpVerification", { state: { mobileno: formData.mobileno } }); 
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.message, life: 3000 });
            }
        } catch (error) {
            console.error("Login Error:", error);
            
            if (error.response) {
                const errorMessage = error.response.data?.message || "Invalid Credentials";
                toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Network Error', life: 3000 });
            }
        }
        setLoading(false);
    };
    
    useEffect(() => {
        localStorage.removeItem('mobileno');

        /*
         * Already signed in? Go where a fresh sign-in goes.
         *
         * Two fixes in one. It pointed at product_details while the OTP screen
         * now lands on inventory, so arriving here with a session took you
         * somewhere different from logging in. And it trusted `authtoken`
         * alone: CustomAxios refuses any request without BOTH tokens and
         * clears storage and returns to this page when one is missing, so half
         * a session produced a silent bounce straight back here.
         */
        const token = localStorage.getItem('authtoken');
        const refresh = localStorage.getItem('refreshToken');
        if (token && refresh) {
            dispatch(updatepageName("inventory"));
            navigate("/home/inventory");
        } else if (token || refresh) {
            localStorage.removeItem('authtoken');
            localStorage.removeItem('refreshToken');
        }
      }, []);
      
      const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleSubmit(event);
        }
      };
      
    return (
        <Box sx={{ width: "100%",height:"100vh",display:{xs: "block", sm:"flex"}}}>
            <Toast ref={toast} />
                <Box sx={{ width:{ sm:"55%", md:"65%"} ,height:{ xs:"60%", sm:"auto"} , display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box component="img" src={hero} sx={{ width: "100%", height: "100%", objectFit: "cover" }}></Box>
                </Box>
                <Box sx={{ width: { sm:"45%", md:"35%"}, height:{ xs:"40%", sm:"auto"}, display: "flex", justifyContent: "center", alignItems: "center", flexDirection:"column", gap:"20px" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Typography sx={{ color: "text.login", fontWeight: "400", fontSize:"14px", textAlign: "left", width: "100%" }}>
                        Mobile Number
                    </Typography>
                    <InputBase
                        name="mobileno"
                        type="tel"
                        value={formData.mobileno}
                        inputProps={{
                            maxLength: 10,
                            inputMode: "numeric",
                            pattern: "[0-9]*"
                        }}
                        sx={{ backgroundColor: "#fff", height: "36px", borderRadius: "2px", padding: "12px 8px", border: "1px solid", borderColor: "secondary.border", width: "268px", fontSize: "14px", fontWeight: "400" }}
                        placeholder="Enter registered mobile number"
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                    />
                </Box>
                <Button 
                    variant="contained" 
                    onClick={(e) => handleSubmit(e)} 
                    disabled={isDisabled || loading} 
                    sx={{ 
                        width: "268px", 
                        height: "32px", 
                        borderRadius: "2px", 
                        backgroundColor: isDisabled ? "#ccc" : "primary.main",
                        color: isDisabled ? "#888" : "white",
                        "&:hover": {
                            backgroundColor: isDisabled ? "#ccc" : "primary.dark",
                        } 
                    }}
                >
                    {loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Get OTP'}
                </Button>
            </Box>
        </Box>
    )
}